import { buildQueryParamString } from "@dxlm/contexts";

export const camelCaseToUserText = (input: string): string => (
  `${input[0].toUpperCase()}${input.replace(/([A-Z](?=[a-z]+)|[A-Z]+(?![a-z]))/g, ' $1').slice(1)}`
);

export const formatRoute = (route: string, routeParams: Record<string, string>, queryParams?: Record<string, string>): string => {
  let formattedRoute = `${route}`;

  Object.keys(routeParams).forEach((key) => {
    formattedRoute = formattedRoute.replace(`:${key}`, encodeURIComponent(routeParams[key]));
  });

  let queryParamsString = '';
  if (queryParams) {
    queryParamsString = buildQueryParamString(queryParams);
  }

  return `${formattedRoute}${queryParamsString}`;
}

export const plurify = (singularText: string, value: number): string => {
  if (!singularText) return '';

  if (singularText.endsWith('y')) return `${singularText.substring(0, singularText.length - 1)}ies`;

  return `${singularText}${value !== 1 ? 's' : ''}`;
};